(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      content: '[data-content]',
      input: '[data-variant-id-input]',
      sellingPlanInput: 'input[name="selling_plan"]'
    };

    async render() {
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';

      this.listenTo('variantChange', (e, data) => {
        this._rerender(data);
        if (data.variant) {
          this._rerenderVariantInput(data);
        }
      });

      this.on('cartChange', (e, data) => {
        this._updateQtyStatus(data.variantId);
      }, false);

      if (this.hasAttribute('cart-popup')) {
        // submit を async にしたいので bind 先はそのまま _handleSubmit
        this.$form.addEventListener('submit', this._handleSubmit.bind(this));
      }

      if (this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
        const { observeInputValueChange } = await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this));
      }
    };

    _handleSellingPlanChange(newSellingPlanId) {
      if (newSellingPlanId === this.currentSellingPlanId)
        return;

      this.currentSellingPlanId = newSellingPlanId;
      const { queryURL, currentURL } = updateURLParams(
        { 'selling_plan': this.currentSellingPlanId, 'variant': this.getAttribute('current-variant') },
        this.sectionId
      );

      if (this.isProductPage) historyPush(currentURL);

      this._fetchPageWithVariant(queryURL, html => {
        this.forwardEvent('sellingPlanChange', { html: html });
      });
    };

    _enableInput() {
      this.$input.disabled = false;
    }

    _fetchPageWithVariant(url, onResponse) {
      return fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = parseHTML(responseText);
          onResponse(html);
        });
    }

    _rerender(data) {
      const source = data.html.querySelector(`#${this.getAttribute('form-id')} [data-content]`);
      if (this.$content) { // コード修正
        this.$content.replaceChildren(...source.cloneNode(true).childNodes);
      }
      this._rerenderPaymentButton();
    }

    _rerenderVariantInput(data) {
      this.setAttribute('current-variant', `${data.variant.id}`);
      const value = data.html.querySelector(this.elements.input).value;
      this.$input.value = value;
    }

    _rerenderPaymentButton() {
      if (window.Shopify?.PaymentButton?.init) {
        window.Shopify.PaymentButton.init();
      }
    }

    /**
     * ✅ 追加：現在選択されている variant が在庫ありかを判定
     * - 同じ section を variant 指定で取りに行き、ボタン表示状態から判定する（テーマに依存しにくい）
     */
    async _isCurrentVariantAvailable(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      const res = await fetch(url);
      const text = await res.text();
      const html = parseHTML(text);

      const formRoot = html.querySelector(`#${this.getAttribute('form-id')}`);
      const soldOutBtn = formRoot?.querySelector('[data-sold-out-button]');
      const addBtn = formRoot?.querySelector('[data-add-button]');

      const soldOutVisible = !!(soldOutBtn && !soldOutBtn.hasAttribute('hidden'));
      const addHidden = !!(addBtn && addBtn.hasAttribute('hidden'));

      // soldOut が見えている or add が隠れている → 在庫なし
      return !(soldOutVisible || addHidden);
    }

    /**
     * ✅ 修正：submit 時に在庫チェックして、在庫なしなら追加を止める
     */
    async _handleSubmit(e) {
      e.preventDefault();
      this.formData = new FormData(e.target);

      const variantId = this.formData.get('id');

      try {
        const ok = await this._isCurrentVariantAvailable(variantId);

        if (!ok) {
          alert('在庫切れのため購入できません。');
          // 表示も最新状態へ寄せる（任意）
          this._updateQtyStatus(variantId);
          return;
        }

        this._addToCartRequest();
      } catch (err) {
        // 判定に失敗した場合は安全側（=追加しない）
        console.log(err);
        alert('在庫確認に失敗しました。お手数ですが時間をおいて再度お試しください。');
        this._setLoading(false);
      }
    }

    _addToCartRequest() {
      this._setLoading(true);

      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          "Accept": "application/javascript"
        },
        body: this.formData
      })
        .then(res => res.json())
        .then(() => {
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);
              this._updateQtyStatus(this.formData.get('id'));

              if (this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          })
        })
        .catch(error => {
          this._setLoading(false);
          console.log(error);
        });
    }

    _updateQtyStatus(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      this._fetchPageWithVariant(url, html => {
        this.trigger('qtyStatusUpdate', { html: html, variantId: variantId });
        this._rerender({ html: html });
      });
    }

    _setLoading(status) {
      status
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
    }
  });
})();
